import * as ua from "@utils/ua"
import * as mqqApi from "@api/mqq"

const userAgent = ua.getUserAgent()
// 构造地址
export function appJumpLink({ cid, vid, type = "" }) {
  let link = ""
  let s = type == "more" ? "/pages/index/index?channelId=100101" : `preload_play/play/index.html?vid=${vid || ""}&cid=${cid || ""}`
  if (userAgent.QQ) {
    link = `${s}&via=1019_2`
  } else if (userAgent.weixin) {
    link = s
  }
  return link
}

// 打开小程序
export function jumpToAppItem({ cid, vid, type = "" }) {
  if (cid || vid || type) {
    if (userAgent.QQ) {
      // 打开qq小程序
      mqqOpenApp({ cid, vid, type })
    } else if (userAgent.weixin) {
      // 打开微信小程序
    }
  }
}

// qq或wx环境且有cid或vid ,微信且wxconfig 注入成功
export function isSupportTerminal({ cid = "", vid = "", isWxConfigSuccess = false, type = "" }) {
  if ((userAgent.QQ || userAgent.weixin) && (cid || vid || type == "more")) {
    if (userAgent.weixin && !isWxConfigSuccess) {
      return false
    }
    return true
  }
  return false
}

export function mqqOpenApp({ cid, vid, type = "" }) {
  mqqApi.initMqqJsApi().then(mqq => {
    let path = type == "more" ? "/pages/index/index?channelId=100101" : `/preload_play/play/index.html?vid=${vid || ""}&cid=${cid}`
    mqq.invoke(
      "miniApp",
      "openApp",
      {
        appid: "1109840991",
        via: "1019_2",
        path: path
      },
      function (data) {
        if (data.ret == 0) {
          // 呼起成功
        } else {
          // 呼起失败
          console.log(data.msg) // 呼起失败原因
        }
      }
    )
  })
}
